import type { HelpFile } from '../../types/help'
import { AttributeDefinitionsTestIds } from '../../../testids/AttributeDefinitionsTestIds'

export const attributeDefinitionsHelp: HelpFile = {
  docPage: '/docs/schema/attribute-definitions',
  texts: {
    [AttributeDefinitionsTestIds.attributeDefinitionsPage]: 'Attribute definitions for parties, identities, accounts, and resources — controls which fields appear on each entity type.',
    [AttributeDefinitionsTestIds.colActions]: null,
    [AttributeDefinitionsTestIds.colActive]: 'Whether this attribute is active and visible on entities.',
    [AttributeDefinitionsTestIds.colAuthority]: 'Authoritative data source — informational only, does not restrict edits.',
    [AttributeDefinitionsTestIds.colDisplayName]: null,
    [AttributeDefinitionsTestIds.colDragHandle]: 'Drag to reorder this attribute relative to others in the form.',
    [AttributeDefinitionsTestIds.colFilterable]: 'Whether this attribute is available as a filter on list pages.',
    [AttributeDefinitionsTestIds.colName]: 'Machine-readable key used by the API, rules, and expression engine.',
    [AttributeDefinitionsTestIds.colRequired]: 'Whether a value is required when creating an entity of this type.',
    [AttributeDefinitionsTestIds.colSearchable]: 'Whether this attribute is indexed for full-text search.',
    [AttributeDefinitionsTestIds.colValueType]: 'Data type — string, number, date, boolean, or entity reference.',
    [AttributeDefinitionsTestIds.createDefinitionButton]: null,
    [AttributeDefinitionsTestIds.definitionActionDelete]: 'Permanently delete this attribute definition.',
    [AttributeDefinitionsTestIds.definitionActionRemoveFromType]: 'Remove this definition from the current entity type without deleting it.',
    [AttributeDefinitionsTestIds.definitionActiveFilter]: 'Show active, inactive, or all attribute definitions.',
    [AttributeDefinitionsTestIds.reorderDisabledBanner]: 'Drag-to-reorder is disabled while a filter or sort is active — clear them first.',
  },
}
